import Resource from './Resource';

export default class Rules extends Resource{
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let config = {
			route: "roles/:role/rules",
			routeParams: routeParams,
			query: query
		};

		super(config);
		return this;
	}

	get(){
		return this.request();
	}
}
